import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ClientList = lazy(() => import('@components/Client/ClientList'));

/** 마스터 계정 > 회사 관리 */
const Client = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ClientList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Client;
